import { makeStyles, mergeClasses, shorthands } from '@griffel/react';

import { BorderRadius } from '../../../../util/styles/borders';
import { getGutterValue } from '../../../../util/styles/gutters';
import { px } from '../../../../util/styling';
import { coreuiTokens } from '../../../../util/theme/fluent9';

interface Props {
  readonly hasBackground: boolean;
  readonly isWide: boolean;
  readonly shouldShowAtCurrentBreakpoint: boolean;
  readonly isNewNavRedesign: boolean;
}

type UseClassName = (props: Props) => string;
export const useClassName: UseClassName = ({
  hasBackground,
  isWide,
  shouldShowAtCurrentBreakpoint,
  isNewNavRedesign,
}) => {
  const classNames = useHeroBackgroundClasses();
  const shouldShowBackground = shouldShowAtCurrentBreakpoint && hasBackground;

  return mergeClasses(
    classNames.root,
    shouldShowBackground && classNames.backgroundGradient,
    shouldShowBackground && isWide && classNames.wide,
    shouldShowBackground && isNewNavRedesign && classNames.newNavRedesign
  );
};

const useHeroBackgroundClasses = makeStyles({
  root: {
    height: '100%',
  },
  backgroundGradient: {
    height: 'auto',
    minHeight: '100%',
    backgroundImage: `linear-gradient(200deg, ${coreuiTokens.colorBlueBackgroundGradient} 16%, transparent 28%)`,
    backgroundSize: '100% 100vw',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 0,
    backgroundPositionY: 0,
    paddingTop: px(12),
    ...shorthands.margin(getGutterValue(2), 'auto', '0'),
  },
  wide: {
    ...shorthands.borderRadius(BorderRadius.VeryRound, BorderRadius.VeryRound, 0, 0),
    marginRight: getGutterValue(6),
    marginLeft: getGutterValue(6),
  },
  newNavRedesign: {
    ...shorthands.borderRadius(0),
    ...shorthands.margin(0),
    paddingTop: 0,
  },
});
